import _ from 'lodash';
import { call, put, select } from 'redux-saga/effects';

import fetchList from './services/fetchList';
import * as actions from '../state';

const scopeList = () => [
  'Call Center Supervisor',
  'Call Center Agent',
];

const fetchListTask = ({ decodedToken, object }) => {
  if (object === 'scope') return scopeList();

  return fetchList({
    domain: decodedToken ? decodedToken.domain : '*',
    user: decodedToken ? decodedToken.user : '*',
    object,
  });
};

function enforceFilters(fetchedList, object, forcedFilters) {
  switch (object) {
    case 'subscriber':
      if (forcedFilters.agent) {
        const deptList = forcedFilters.agent.split(',');
        return _.remove(fetchedList, (n) => deptList.includes(n.group) || deptList.includes(n.site));
      }
      break;
    case 'callqueue':
      if (forcedFilters.queue) {
        const queueList = forcedFilters.queue.split(',');
        return _.remove(fetchedList, (n) => queueList.includes(n.queue_name));
      }
      break;
    case 'site':
    case 'department':
      if (forcedFilters.agent) {
        const deptList = forcedFilters.agent.split(',');
        return _.remove(fetchedList, (n) => deptList.includes(n));
      }
      break;
    default:
  }

  return fetchedList;
}

function formatList(fetchedList, object) {
  switch (object) {
    case 'subscriber':
      return fetchedList.map((subscriber) => ({
        type: object,
        name: `${subscriber.first_name} ${subscriber.last_name}`,
        value: `${subscriber.user}@${subscriber.domain}`,
        desc: subscriber.user,
      }));
    case 'scope':
      return fetchedList.map((scope) => ({
        type: object,
        name: `All ${scope}s`,
        value: scope,
      }));
    case 'callqueue':
      return fetchedList.map((callqueue) => ({
        type: object,
        name: callqueue.queue_name,
        value: callqueue.queue_name,
        desc: callqueue.description !== callqueue.queue_name ? callqueue.description : null,
      }));
    default:
      return fetchedList.map((listItem) => ({
        type: object,
        value: listItem,
      }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* loadAutocompleteChoices(decodedToken, objects) {
  const forcedFilters = {};
  forcedFilters.queue = yield select((state) => actions.selectConfig(state, 'PORTAL_CALL_QUEUE_MANAGER_VIEW_LIST'));
  forcedFilters.agent = yield select((state) => actions.selectConfig(state, 'PORTAL_CALL_QUEUE_MANAGER_AGENT_GROUPS'));

  try {
    let choices = [];

    if (objects.length) { // if multiple objects are requested
      for (let i = 0; i < objects.length; i += 1) {
        const object = objects[i];
        const fetchedList = yield call(fetchListTask, { decodedToken, object });
        const filteredList = enforceFilters(fetchedList, object, forcedFilters);

        choices[object] = formatList(filteredList, object);
      }
    } else { // if a single object is requested
      const object = objects;
      const fetchedList = fetchListTask(decodedToken, object);
      const filteredList = enforceFilters(fetchedList, object, forcedFilters);

      choices = formatList(filteredList, object);
    }

    yield put(actions.setAutocompleteChoices(choices));
  } catch (error) {
    console.error(error);
  }
}
